import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import MediaQuery from 'react-responsive'
import { getButton } from 'Shared/GTM/getButton'
import PropTypes from 'prop-types'

const Header = ({ profile }) => {
  return (
    <MediaQuery minWidth={992}>
      <nav className='nav-menu-shopping col-12'>
        <div className='container d-flex justify-content-around align-items-center py-2 p-0'>
          <a href='/' className='shopping-logo' />
          <ul className='d-flex col-7 justify-content-around'>
            <li>
              <AnchorLink
                role='menuitem'
                href='#homeShopping'
                data-target='#homeShopping'
                className='brand-1-shopping-color'
                onClick={() => {
                  getButton(profile, 'landing-shopping', 'clique:menu', 'inicio')
                }}
              >
                Inicio
              </AnchorLink>
            </li>

            <li>
              <AnchorLink
                role='menuitem'
                href='#howItWork'
                data-target='#howItWork'
                className='brand-1-shopping-color'
                onClick={() => {
                  getButton(profile, 'landing-shopping', 'clique:menu', 'como-funciona')
                }}
              >
                Como funciona
              </AnchorLink>
            </li>
            <li>
              <AnchorLink
                role='menuitem'
                href='#partner'
                data-target='#partner'
                className='brand-1-shopping-color'
                onClick={() => {
                  getButton(profile, 'landing-shopping', 'clique:menu', 'parceiros')
                }}
              >
                Parceiros
              </AnchorLink>
            </li>
            <li>
              <AnchorLink
                role='menuitem'
                href='#help'
                data-target='#help'
                className='brand-1-shopping-color'
                onClick={() => {
                  getButton(profile, 'landing-shopping', 'clique:menu', 'duvidas-frequentes')
                }}
              >
                Dúvidas frequentes
              </AnchorLink>

            </li>
          </ul>
        </div>
      </nav>
    </MediaQuery>
  )
}

Header.propTypes = {
  profile: PropTypes.object
}

export default Header



// WEBPACK FOOTER //
// ./src/features/Landings/HomePageShopping/components/Header/Header.js